












import Vue from 'vue';
import ShredderCalculator from './components/ShredderCalculator.vue';
import { InputData } from './DataStructure'
const inputData = require("./data.yml") as InputData

export default Vue.extend({
  name: 'App',
  components: {
    ShredderCalculator
  },
  data: function() {
    return {
      inputData: inputData.shredders[0]
    }
  }
});
